import { SelectionButtonsValueParams } from './SelectionButtons';
import { useQueryFilters } from '@hooks/useQueryFilters';

interface UrlTabSelection<T extends string> {
    tabsItems: SelectionButtonsValueParams[];
    activeTabIndex: T;
    setTabIndex(key: T): void;
}

type UrlQuery = Record<string, string | undefined>;

export function useUrlTabSelection<T extends string = string>(
    queryKey: string,
    tabsItems: SelectionButtonsValueParams[],
): UrlTabSelection<T> {
    const { getQueryFilterParams, updateQueryFilterParams } = useQueryFilters<UrlQuery>();
    const defaultTab = (tabsItems[0]?.value?.toString() ?? '') as T;
    const activeTabIndex = (getQueryFilterParams()[queryKey] ?? defaultTab) as T;

    function setTabIndex(key: T): void {
        updateQueryFilterParams({ [queryKey]: key === defaultTab ? undefined : key });
    }

    return {
        tabsItems,
        activeTabIndex,
        setTabIndex,
    };
}
